import React from "react";
import { styled } from "@mui/material";

const StyledSpan = styled("span", {
  shouldForwardProp: prop =>
    prop !== "color" &&
    prop !== "ml" &&
    prop !== "fontWeight" &&
    prop !== "fontSize",
  name: "Link"
})<{
  color?: string;
  ml?: number | string;
  fontWeight?: number;
  fontSize?: number;
  isUnderLine?: boolean;
}>(
  ({
    color = "black",
    ml,
    theme,
    fontWeight = 500,
    fontSize,
    isUnderLine = true
  }) => ({
    color: theme.palette.common[color],
    marginLeft: ml,
    textDecoration: isUnderLine ? "underline" : undefined,
    cursor: "pointer",
    fontWeight,
    fontSize: fontSize || theme.typography.h5.fontSize
  })
);
export interface LinkInterface {
  onClick: () => void;
  label: string;
  color?: string;
  ml?: number | string;
  fontWeight?: number;
  fontSize?: number;
  isUnderLine?: boolean;
}
const Link = ({
  onClick,
  label,
  color,
  ml,
  fontWeight,
  fontSize,
  isUnderLine = true
}: LinkInterface) => {
  return (
    <StyledSpan
      onClick={onClick}
      color={color}
      ml={ml}
      fontWeight={fontWeight}
      fontSize={fontSize}
      isUnderLine={isUnderLine}
    >
      {label}
    </StyledSpan>
  );
};
export default Link;
